import { useCallback, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldError, Input, Label, TextField } from 'react-aria-components';
import { useSelector, useDispatch } from 'react-redux';
import { selectName, selectUrl } from '@pages/admin/article/store/selectors';
import { setName, setUrl } from '@pages/admin/article/store/slice';
import { isValidUrl } from '@components/utils';



export const Base = () => {
	const { t } = useTranslation('admin');

	const name = useSelector(selectName);
	const url = useSelector(selectUrl);
	const dispatch = useDispatch();
	const dispatchSetName = (name: string) => dispatch(setName(name));
	const dispatchSetUrl = (url: string) => dispatch(setUrl(url));

	const validateUrl = useCallback((value: string): string | true => {
		if (!value || value.length === 0) return 'Povinné pole';
		if (!isValidUrl(value)) return 'URL může obsahovat pouze písmena, číslice, a znaky - . _ ~';
		return true;
	},[]);


	return (
		<div className='form-base'>
			
			<TextField name='name' type='text' isRequired>
				<Label>{t('pages.article.articleForm.base.nameLabel')}:</Label>
				<Input
					maxLength={50}
					value={name}
					onChange={(event: ChangeEvent<HTMLInputElement>) => {
						dispatchSetName(event.target.value);
					}}
				/>
				<FieldError />
			</TextField>
			
			<TextField name='url' type='text' isRequired validate={validateUrl}>
				<Label>{t('pages.article.articleForm.base.urlLabel')}:</Label>
				<Input
					maxLength={50}
					value={url}
					onChange={(event: ChangeEvent<HTMLInputElement>) => {
						const inputValue = event.target.value;
						let filteredValue = inputValue
							.replace(/\s/g, '')
							.toLowerCase();
						dispatchSetUrl(filteredValue);
					}}
				/>
				<FieldError />
			</TextField>

		</div>
	)
}